import EntityMember from "_shared/entity-members/entity-member";
import Guid from "_shared/guids/guid";
import Name from "_shared/names/name";

export default class SelectedVendorTeamLeader {
  public static fromURLSearchParams(params: URLSearchParams): SelectedVendorTeamLeader | undefined {
    const userIdParam = params.get("tUserId");
    const entityIdParam = params.get("tEntityId");
    const hasSigningAuthorityParam = params.get("tHasSigningAuthority");
    const firstNameParam = params.get("firstName");
    const lastNameParam = params.get("lastName");

    if (!userIdParam || !entityIdParam || !hasSigningAuthorityParam || !firstNameParam || !lastNameParam) {
      return undefined;
    }

    return new SelectedVendorTeamLeader({
      userId: new Guid(userIdParam),
      legalEntityId: new Guid(entityIdParam),
      hasSigningAuthority: hasSigningAuthorityParam === "true",
      name: Name.create({ params: { firstName: firstNameParam, lastName: lastNameParam } }),
    });
  }
  public readonly userId: Guid;
  public readonly legalEntityId: Guid;
  public readonly name: Name;

  public readonly hasSigningAuthority: boolean;

  constructor(params: { userId: Guid; legalEntityId: Guid; name: Name; hasSigningAuthority: boolean }) {
    this.userId = params.userId;
    this.legalEntityId = params.legalEntityId;
    this.name = params.name;
    this.hasSigningAuthority = params.hasSigningAuthority;
  }

  /** The new draft proposal with this rep as its vendor team leader. */
  public generateTargetUrl(location: Location): URL {
    const url = new URL("/proposals/drafts/create", location.origin);
    url.searchParams.append("tUserId", this.userId.value);
    url.searchParams.append("tEntityId", this.legalEntityId.value);
    url.searchParams.append("tHasSigningAuthority", this.hasSigningAuthority.toString());
    url.searchParams.append("firstName", this.name.firstName?.toString() ?? "");
    url.searchParams.append("lastName", this.name.lastName?.toString() ?? "");

    return url;
  }

  public toJSON(): Record<string, unknown> {
    return {
      userId: this.userId.value,
      legalEntityId: this.legalEntityId.value,
      hasSigningAuthority: this.hasSigningAuthority,
      name: this.name.toJSON(),
    };
  }
  public toEntityMember(): EntityMember {
    return new EntityMember({
      userId: this.userId,
      legalEntityId: this.legalEntityId,
    });
  }
}
